/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PlanOfCareLocatorItemsBySignatureViewModel } from './PlanOfCareLocatorItemsBySignatureViewModel'; 

export function getPlanOfCareLocatorItemsBySignatureIdOptions(signatureId: string, onSuccess?: (result: PlanOfCareLocatorItemsBySignatureViewModel) => void) {
	return queryOptions({
		queryKey: ['plan-of-care-locator-items-by-signature-id', signatureId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/plansofcare/queries/getplanofcarelocatoritemsbysignatureid/' + signatureId;
			const resp = await axios.get<PlanOfCareLocatorItemsBySignatureViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(signatureId)
	});
}